import React from 'react';
import { Box, Typography, Divider, Button } from '@mui/material';
import { DynamicIcon } from '../components/icons.jsx';
import { useNotification } from '../context/NotificationContext.jsx';

const GeneralSettings = ({ user }) => {
    const { addNotification } = useNotification();

    const handleCopyId = () => {
        navigator.clipboard.writeText(user?.tenantId || '');
        addNotification("Tenant ID copied to clipboard", "success");
    };

    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', p: 3, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
            <Typography variant="h6" gutterBottom fontWeight="bold">Tenant Information</Typography>
            <Divider sx={{ mb: 3 }} />

            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 2, mb: 3, alignItems: 'center' }}>
                <Typography variant="subtitle2" color="text.secondary">Tenant Name</Typography>
                <Typography variant="body1" fontWeight="500">{user?.tenant?.name || user?.tenantId || 'Unknown Tenant'}</Typography>
            </Box>

            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 2, mb: 3, alignItems: 'center' }}>
                <Typography variant="subtitle2" color="text.secondary">Tenant ID</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', bgcolor: 'action.hover', p: 0.5, borderRadius: 1 }}>
                        {user?.tenantId}
                    </Typography>
                    <Button size="small" startIcon={<DynamicIcon name="Copy" className="w-4 h-4" />} onClick={handleCopyId}>
                        Copy
                    </Button>
                </Box>
            </Box>

            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 2, alignItems: 'center', mb: 3 }}>
                <Typography variant="subtitle2" color="text.secondary">Region</Typography>
                <Typography variant="body2">US-East (Virginia)</Typography>
            </Box>

            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 2, alignItems: 'center' }}>
                <Typography variant="subtitle2" color="text.secondary">Plan</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body1" fontWeight="bold" color="primary">{user?.planName || 'Free'}</Typography>
                    <DynamicIcon name="CheckCircle" className="w-4 h-4 text-green-500" />
                </Box>
            </Box>
        </Box>
    );
};

export default GeneralSettings;
